import medMutationHooks from './medMutationHooks.ts';
import recallMutationHooks from './recallMutationHooks.ts';
import outboundDocumentMutationHooks from './outboundDocumentMutationHooks.ts';
import userMutationHooks from './userMutationHooks.ts';
import tradingPartnerMutationHooks from './tradingPartner.ts';

export default {
  med: medMutationHooks,
  outboundDocument: outboundDocumentMutationHooks,
  recall: recallMutationHooks,
  tradingPartner: tradingPartnerMutationHooks,
  user: userMutationHooks,
};
